import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './Main.module.css';
import moment from 'moment';
import { getDocumentsListAll } from 'apis/modusign';
import { docTypeList } from 'constants/config';
import { IsLoginContext, useIsLoginState } from 'auth/IsLoginContext'
import { validateToken, parsePermissionsFromToken } from 'auth/ValidateToken';

import Datepicker from 'components/datepicker/Datepicker';
import Tooltip from 'components/tooltip/Tooltip';
import MiniTooltip from 'components/tooltip/MiniTooltip';

const FinanceMain = () => {
  const navigate = useNavigate();

  const [currentConnectDiv, setCurrentConnectDiv] = useState(); // 접속 구분 (finance / bizops)
  const [clickDownloadToggle, setClickDownloadToggle] = useState(false); // 다운로드 버튼 토글

  // 검색 일자
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // 다운로드 진행 정보
  const [progressInfo, setProgressInfo] = useState();

  // 현재 작업ID
  const [currentJobId, setCurrentJobId] = useState();

  // 다운로드 이력
  const [currentDownloadHistory, setCurrentDownloadHistory] = useState();

  // 로그인 정보
  const { setIsLogin } = useContext(IsLoginContext);
  const isLogin = useIsLoginState();

  // 전체 체크박스
  const handleCheckAll = () => {
    const checkAll = document.querySelector('#checkAll');
    const checkList = document.querySelectorAll('input[name=docType]');

    checkList.forEach((item) => {
      item.checked = checkAll.checked;
    });
  }

  // 체크박스 클릭
  const handleClickCheckbox = () => {
    const checkList = document.querySelectorAll('input[name=docType]');
    const checkedList = document.querySelectorAll('input[name=docType]:checked');
    const allcheckbox = document.querySelector('#checkAll');

    if (checkList.length === checkedList.length) {
      allcheckbox.checked = true;
    } else {
      allcheckbox.checked = false;
    }
  }

  // 다운로드
  async function downloadExcels() {
    // const docTypeList = [];
    const numStartDate = Number(moment(startDate).format('YYYYMMDD'));
    const numEndDate = Number(moment(endDate).format('YYYYMMDD'));

    if (numStartDate > numEndDate) {
      alert('시작일은 종료일보다 클 수 없습니다.');
      return;
    }

    const checkedRadio = document.querySelector('input[name=docType]:checked').value;

    // const checkedAll = document.querySelectorAll('input[name=docType]:checked');
    // const checkedList = document.querySelectorAll('input[name=docType]:checked');

    // if (checkedAll.length == 0) {
    //   alert('계약서 타입을 선택해주세요!');
    //   return;
    // }

    // 체크한 문서 타입
    // checkedList.forEach((item) => {
    //   docTypeList.push(item.value);
    // });

    const dateRange = [];
    dateRange.push(moment(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'));

    const isToday = moment(endDate).format('YYYY-MM-DD') === moment(new Date()).format('YYYY-MM-DD');
    if (isToday) {
      dateRange.push(moment(endDate).format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'));
    } else {
      dateRange.push(moment(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'));
    }

    const elem = {
      dateRange: dateRange,
      selectedDocType: checkedRadio,
      // selectedDocTypeList: docTypeList,
    }

    try {
      let requestInfo = await getDocumentsListAll(elem);

      if (!requestInfo || requestInfo.document_list.length === 0) {
        alert ('입력하신 조건에 해당하는 계약서가 없습니다.');
        return;
      }

      setClickDownloadToggle(true);

      requestInfo = {
        ...requestInfo,
        req_div: currentConnectDiv,
      }

      // console.log('requestInfo ', requestInfo);

      // 서버 요청
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/request`, requestInfo).then((res) => {
        if (res.data.job_id) {
          setCurrentJobId(res.data.job_id);
        }
        checkProgress(res.data.job_id);
      });

    } catch (error) {
      console.log(error);
      if (error.response.data.detail) {
        alert(`[ERROR_CODE: ${error.response.status}] ${error.response.data.detail}`);
      }
    }
  }

  // 처리 결과 조회
  const checkProgress = async(jobId) => {
    setClickDownloadToggle(true);
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/progress?req_div=${currentConnectDiv}`;

      if (jobId) {
        url += `&job_id=${jobId}`;
        setCurrentJobId(jobId);
      } else if (currentJobId) {
        url += `&job_id=${currentJobId}`;
      }

      // req_div, job_id
      await axios.get(url).then((res) => {
        setProgressInfo(res.data);
      });
    } catch (error) {
      setClickDownloadToggle(false);
      console.log(error);
    }
  }

  // 다운로드 중지
  const stopDownload = async () => {
    const data = {
      job_id: currentJobId
    }
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/stop`, data).then((res) => {
        checkProgress();
        setClickDownloadToggle(false);
        setProgressInfo(res.data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  // 다운로드 이력 조회
  const getDownloadHistory = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history?req_div=${currentConnectDiv}&limit=3`).then((res) => {
        setCurrentDownloadHistory(res.data.history);
      });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    let intervalId;

    if (clickDownloadToggle) {
      // 클릭 토글이 true인 경우에만 실행
      intervalId = setInterval(checkProgress, 5000);
    }

    return () => {
      // 컴포넌트가 언마운트되거나 clickDownloadToggle이 false가 되면 interval을 클리어
      clearInterval(intervalId);
    };
  }, [clickDownloadToggle]);

  // useEffect(() => {
  //   if (clickDownloadToggle) {
  //     // 5초마다 처리 결과 조회 함수 호출
  //     const interval = setInterval(checkProgress, 5000);

  //     if (progressInfo && progressInfo.complete) {
  //       clearInterval(interval);
  //     }
  //   } else {
  //     clearInterval(checkProgress);
  //   }
  // }, [clickDownloadToggle]);

  useEffect(() => {
    if (currentConnectDiv) {
     getDownloadHistory();
    }
  }, [currentConnectDiv]);

  useEffect(() => {
    if (progressInfo && progressInfo.complete) {
      setClickDownloadToggle(false);
    }
    if (progressInfo && !currentJobId) {
      setCurrentJobId(progressInfo.job_id)
    }
  }, [progressInfo]);

  useEffect(() => {
    const replacedUrl = window.location.pathname;
    if (replacedUrl.includes('finance')) {
      setCurrentConnectDiv('finance');
    }

    if (replacedUrl.includes('bizops')) {
      setCurrentConnectDiv('bizops');
    }
  }, []);

  useEffect(() => {
    const isUseAuth = (process.env.REACT_APP_USE_AUTH === 'Y');
    (async () => {
      if (currentConnectDiv && isUseAuth) {
        const accessToken = localStorage.getItem('access_token');
        const tvresult = await validateToken(accessToken);
        if (!tvresult) {
          navigate("/unauthorized")
        }

        const permissions = await parsePermissionsFromToken(accessToken);
        if (permissions.length === 0) {
          navigate("/unauthorized")
        }

        if (!(permissions.includes(currentConnectDiv))) {
          navigate("/unauthorized")
        }
      }
    // const authorize = async () => {

    })();

    // authorize();
  })

  return (
    <div className={styles['container']}>
      <div className={styles['wrap']}>
        <div className={styles['title']}>계약서 PDF 추출</div>
        <div className={styles['calendar']}>
          <div className={styles['calendar-input']}>
            <p>시작일</p>
            <Datepicker setDate={setStartDate} />
          </div>
          <div className={styles['calendar-input']}>
            <p>종료일</p>
            <Datepicker setDate={setEndDate} />
          </div>
          <div className={styles['tooltip']}>
            <Tooltip content={currentDownloadHistory} />
          </div>
        </div>
        <div className={styles['bottom-wrap']}>
          {/* checkbox */}
          {/* <div className={styles['check-wrap']}>
            <label>
              <input type='checkbox' className='checkbox' id='checkAll' onClick={() => handleCheckAll()} /> 전체
            </label>
            {docTypeList.map((item, index) => {
              return (
                <label key={index} htmlFor={`docType${index}`}>
                  <input
                    type='checkbox'
                    className='checkbox'
                    name='docType'
                    id={`docType${index}`}
                    value={item.value}
                    onClick={() => handleClickCheckbox()}
                  />
                  {item.label}
                </label>
              )
            })}
          </div> */}

          {/* radio */}
          <div className={styles['radio-wrap']}>
            <label>
              <input type='radio' className='' name='docType' value='0' defaultChecked />
              전체 <MiniTooltip content={'표준계약서 / 양도양수 / 서비스이용일확정서'} />
            </label>
            {docTypeList.map((item, index) => {
              if (item.show) {
                return (
                  <label key={index} htmlFor={`docType${index}`}>
                    <input
                      type='radio'
                      className=''
                      name='docType'
                      id={`docType${index}`}
                      value={item.value}
                    />
                    {item.label}
                  </label>
                )
              }
            })}
          </div>
          <div className={styles['download-btn']} onClick={() => downloadExcels()}>다운로드</div>
          <div className={styles['progress-btn']} onClick={() => checkProgress()}>현황조회</div>

          { progressInfo ?
            <div className={styles['progress']}>
              <div className={styles['prog-item']}>
                <p className={styles['prog-title']}>전체 : </p>
                <p className={styles['prog-desc']}>{progressInfo.total_docs_count + progressInfo.template_docs_count} 건</p>
              </div>
              <div className={styles['prog-item']}>
                <p className={styles['prog-title']}>완료건수 : </p>
                <p className={styles['prog-desc']}>{progressInfo.process_count + progressInfo.template_docs_count} 건</p>
              </div>
              <div className={styles['prog-item']}>
                <p className={styles['prog-title']}>남은건수 : </p>
                <p className={styles['prog-desc']}>{progressInfo.total_docs_count - progressInfo.process_count} 건</p>
              </div>
              <div className={styles['prog-item']}>
                <p className={styles['prog-title']}>진행상태 : </p>
                <p className={styles['prog-desc']}>{progressInfo.status_message}</p>
              </div>
              <div className={styles['prog-item']}>
                <p className={styles['prog-title']}>예상변환시간 : </p>
                <p className={styles['prog-desc']}>{Math.ceil(20 * (progressInfo.total_docs_count - progressInfo.process_count) / 60)} 분</p>
              </div>
              { progressInfo.complete && progressInfo.status !== 'Cancelled' ?
                <div className={styles['prog-btn-wrap']}>
                  <div className={styles['prog-btn']}>
                    <a href={progressInfo.result_xlsx_url}>Excel 다운로드 받기</a>
                  </div>
                </div>
                :
                progressInfo.status !== 'Ready' && progressInfo.status !== 'Cancelled' ?
                <div className={styles['status-wrap']}>
                  <div className={styles['spinner']}>
                    <div className={styles['loader']}></div>
                  </div>
                  <div className={styles['stop-btn']} onClick={() => stopDownload()}>다운로드중지</div>
                </div>
                : ''}
            </div>
          : ''}
        </div>
      </div>
    </div>
  )
}

export default FinanceMain;